export default __webpack_public_path__ + "static/media/Monger-HUD-Readout (EKG).af0a3343.jpg";